"use client";

import { getBookerWrapperClasses } from "@calcom/features/bookings/Booker/utils/getBookerWrapperClasses";
import type { getPublicEvent } from "@calcom/features/eventtypes/lib/getPublicEvent";
import type { BrandSkin } from "@calcom/features/teams/lib/brandSkins";
import { BookerWebWrapper as Booker } from "@calcom/web/modules/bookings/components/BookerWebWrapper";
import BookingPageErrorBoundary from "@components/error/BookingPageErrorBoundary";

import { BrandFrame, BrandLogo, framedBookerClassNames } from "./brand-frame";

type EventData = NonNullable<Awaited<ReturnType<typeof getPublicEvent>>>;

export function TeamTypePublicView({
  teamSlug,
  eventSlug,
  eventData,
  skin,
  isEmbed = false,
}: {
  teamSlug: string;
  eventSlug: string;
  eventData: EventData;
  skin?: BrandSkin | null;
  isEmbed?: boolean;
}) {
  // Logo sur les deux marques (avant : Launchpad seulement).
  const logo = skin ? <BrandLogo skin={skin} /> : null;
  const booker = (
    <main
      className={
        skin && !isEmbed ? "flex w-full items-center justify-center" : getBookerWrapperClasses({ isEmbed })
      }>
      <Booker
        username={teamSlug}
        eventSlug={eventSlug}
        isTeamEvent
        // Les créneaux d'équipe passent sinon par l'API v2 (processus séparé, port 5555).
        // Ici on reste dans l'instance web, via viewer.slots.
        useApiV2={false}
        hideBranding={Boolean(skin)}
        hideOrgTeamAvatar={Boolean(skin)}
        eventMetaLeading={logo}
        customClassNames={skin ? framedBookerClassNames : undefined}
        eventData={eventData}
        entity={{ ...eventData.entity, eventTypeId: eventData.id }}
      />
    </main>
  );

  return (
    <BookingPageErrorBoundary>
      {skin && !isEmbed ? (
        <BrandFrame
          skin={skin}
          width="booker"
          eyebrow={eventData.title}
          meta={`${eventData.length} min · ${eventData.locations?.[0]?.customLabel ?? "Google Meet"}`}>
          {booker}
        </BrandFrame>
      ) : (
        booker
      )}
    </BookingPageErrorBoundary>
  );
}
